import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

import { ValidatorErrorType } from '../../contants/input-field.validation';

@Component({
	selector: 'ipb-input-field',
	templateUrl: './input-field.component.html',
	styleUrls: ['./input-field.component.scss'],
})
export class InputFieldComponent implements OnChanges {
	showPassword = false;

	@Input({ required: true })
	public label!: string;

	@Input()
	public description = '';

	@Input()
	public type: 'number' | 'text' | 'tel' | 'email' | 'password' = 'text';

	@Input({ required: true })
	public controlForm!: FormControl | AbstractControl;

	@Input()
	public maxLength: number | null = 100;

	@Input()
	public minLength?: number | null;

	@Input()
	public lyLetters = false;

	@Input()
	public validationMessages?: ValidatorErrorType[];

	@Input()
	public disabled = false;

	@Output()
	public fieldBlur = new EventEmitter<Event>();

	public get control(): FormControl {
		return this.controlForm as FormControl;
	}

	get errorMessage(): string {
		if (!this?.control?.errors) {
			return '';
		}

		const lastError = Object.keys(this.control.errors).pop();

		const validation = this.validationMessages?.find(
			(validation) => validation.type === lastError,
		);

		if (!validation) {
			return '';
		}

		return validation.message ?? '';
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['disabled']) {
			if (this.disabled) {
				this.control.disable();
			} else {
				this.control.enable();
			}
		}
	}

	public onChangeCheck(event: Event) {
		if (this.lyLetters) {
			const input = event.target as HTMLInputElement;
			const value = input.value.replace(/[^a-zA-Z]/g, '');
			input.value = value;
			this.control.setValue(value);
		}
	}
}
